import EditUser from './EditUser';
import CreateUser from './CreateUser';
import ViewUser from './ViewUser';
import ListUsers from './ListUsers';

export default { EditUser, CreateUser, ViewUser, ListUsers };



// WEBPACK FOOTER //
// ./src/components/pages/admin/users/index.js